import { Route, Routes, useNavigate } from "react-router-dom";
import Task from "./Task/index";
import CheckList from "./Checklist/index";
import Glossary from "./Glossary/index";
import Tutorials from "./Tutorials/index";
import ContentRequestTemplates from "./ContentRequestTemplates/index";
import { InvalidURL } from "commonUI";
import { useUserPermissions } from "hooks/user";
import { useEffect } from "react";
import AddEditTask from "library/Task/AddEditTask";
import AddEditChecklist from "library/Checklist/AddEditChecklist";
import Notes from "./Notes";
import AddEditNotes from "library/Notes/AddEditNotes";
import AddEditGlossary from "library/Glossary/AddEditGlossary";
import AddEditTutorial from "library/Tutorials/AddEditTutorial";
import AddEditContentRequestTemplate from "library/ContentRequestTemplates/AddEditContentRequestTemplate";
import { ModulePrefixes } from "enums";

export default function Library() {
  const { add_items_from_template_library } = useUserPermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (add_items_from_template_library === undefined) return;
    if (
      !add_items_from_template_library &&
      window.location.pathname.startsWith(`/${ModulePrefixes.SITE_TEMPLATE}/library-item/`)
    ) {
      navigate(`/${ModulePrefixes.SITE_TEMPLATE}/interface`);
    }
  }, [add_items_from_template_library, navigate]);
  return (
    <>
      <Routes>
        <Route exact path={`/`}>
          <Route exact index element={<Task />} />
        </Route>
        <Route exact path={`/tasks`}>
          <Route exact index element={<Task />} />
          <Route
            exact
            path="/tasks/:id"
            element={
              <AddEditTask
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/tasks`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route exact path={`/checklists`}>
          <Route exact index element={<CheckList />} />
          <Route
            exact
            path="/checklists/:id"
            element={
              <AddEditChecklist
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/checklists`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route exact path={`/notes`}>
          <Route exact index element={<Notes />} />
          <Route
            exact
            path="/notes/:id"
            element={
              <AddEditNotes
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/notes`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route exact path={`/glossary`}>
          <Route exact index element={<Glossary />} />
          <Route
            exact
            path="/glossary/:id"
            element={
              <AddEditGlossary
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/glossary`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route exact path={`/tutorials`}>
          <Route exact index element={<Tutorials />} />
          <Route
            exact
            path="/tutorials/:id"
            element={
              <AddEditTutorial
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/tutorials`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route exact path={`/content-request-templates`}>
          <Route exact index element={<ContentRequestTemplates />} />
          <Route
            exact
            path="/content-request-templates/:id"
            element={
              <AddEditContentRequestTemplate
                previousPath={`/${ModulePrefixes.SITE_TEMPLATE}/library-item/content-request-templates`}
                isSiteTemplate
              />
            }
          />
        </Route>
        <Route path={`/*`} element={<InvalidURL />} />
      </Routes>
    </>
  );
}
